import { LOCALES } from 'i18n/locales';
import { ProfileService } from 'client/services';
import { HOME_PAGE } from 'client/utils/routes/routeConstants';

const loader = async ({ request }) => {
    if (request.method === 'PATCH') {
        const { modifiedDate, locale = LOCALES.ENGLISH, redirect = HOME_PAGE } = Object.fromEntries(await request.formData());
        if (modifiedDate && locale) {
            await ProfileService.patchAcceptTsAndCs(modifiedDate, locale);
            return { redirect };
        }
    }
    return {};
};

export default loader;
